export const sourceAnotherOption = 'Иное (указать)';
export const sourceOnlineSchoolOption = 'Онлайн-школа';

export const FIELD_NAMES = {
  // Персональная информация
  fullname: 'fullName',
  birthday: 'birthdate',
  country: 'country',
  city: 'city',

  // Контактная информация
  phone: 'phone',
  email: 'email',
  telegram: 'telegram',

  // Образование
  education: 'education',
  englishLevel: 'englishLevel',

  // Дополнительная информация
  specialization: 'specialization',
  direction: 'specializationDirection',
  additionalEducation: 'additionalEducation',
  informationSource: 'informationSource',

  // Дополнительные поля формы
  source: 'source',
  sourceOnlineSchool: 'sourceOnlineSchool',
};

export const ADDITIONAL_FIELDS_NAMES = {
  captchaToken: 'captchaToken',
  referrer: 'referrer',
};
